import { t } from 'i18next';

import { DevelopBanner } from '@app/shared/ui/molecules/Cognition';
import { DEVELOP_BANNERS } from '@app/shared/constants/cognition';
import { S3_HOST } from '@app/assets';

export const DevelopSection = () => {
  const leftColumn = DEVELOP_BANNERS.filter((item) => item.number % 2 === 1);
  const rightColumn = DEVELOP_BANNERS.filter((item) => item.number % 2 === 0);

  return (
    <div className="mt-6!">
      <h3 className="text-lg mb-4 font-semibold">{t('cognition.develop.title')}</h3>

      <div className="grid grid-cols-2 gap-2">
        <ul className="space-y-2">
          {leftColumn.map((item, i) => (
            <li key={item.title + i}>
              <DevelopBanner
                title={t(`cognition.develop.banners.${item.title}`)}
                imgSrc={`${S3_HOST}/pandas/cognition-banners/${item.title}.webp`}
                imgClassName={item.imgClassName}
                bannerClassName={item.bannerClassName}
                cardNumber={item.number}
              />
            </li>
          ))}
        </ul>

        <ul className="space-y-2">
          {rightColumn.map((item, i) => (
            <li key={item.title + i}>
              <DevelopBanner
                title={t(`cognition.develop.banners.${item.title}`)}
                imgSrc={`${S3_HOST}/pandas/cognition-banners/${item.title}.webp`}
                imgClassName={item.imgClassName}
                bannerClassName={item.bannerClassName}
                cardNumber={item.number}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
